import _ from 'underscore';
import { include } from 'underscore.string';

export function localize(schema, schemaI18n, i18n) {
  _.each(schema.properties, (prop, name) => {
    const localizedProp = prop;
    let schemaName = schema.name;
    let propName = name;
    if (prop.property) {
      const names = prop.property.split('/');
      if (names.length > 1) {
        [schemaName, propName] = _.last(names, 2);
      }
    }
    if (!localizedProp.title) {
      localizedProp.title = schemaI18n.property(schemaName, propName);
    }

    // update settings for enum type
    if (!_.isEmpty(prop.enum)) {
      _.defaults(localizedProp, { localized: {} });

      const enumType = localizedProp.enumType ? localizedProp.enumType : localizedProp.name;

      // update enum value (for odata converting) & localization
      _.each(prop.enum, (enumValue) => {
        let localizedValue = '';
        const originalEnumValue = prop.enumValueMap[enumValue];

        try {
          // If enum value contains comma-separated items, localize each item individually
          if (prop.localized[enumValue]) {
            localizedValue = prop.localized[enumValue];
          } else if (include(originalEnumValue, ',')) {
            const separatedEnumValues = originalEnumValue.split(',');
            const localizedEnumValues = [];
            _.each(separatedEnumValues, (individualEnumValue) => {
              localizedEnumValues.push(i18n.getString(`${enumType}_${individualEnumValue}`));
            });
            localizedValue = localizedEnumValues.join(', ');
          } else {
            localizedValue = i18n.getString(`${enumType}_${originalEnumValue}`);
          }
        } catch (e) {
          // continue regardless of error
        }

        if (_.isEmpty(localizedValue)) {
          // Try to get the localized enum value via schemaI18n
          localizedValue = schemaI18n.value(
            schemaName,
            propName, originalEnumValue
          );
        }

        if (!_.isEmpty(localizedValue)) {
          localizedProp.localized[enumValue] = localizedValue;
        }
      });
    } else if (prop.type === 'boolean' && !prop.localized) { // update localization for boolean value
      _.extendOwn(localizedProp, { localized: {} }, _.pick(prop, 'chooseType'));
      // TODO: move this part to component/i18n
      const localizedTrueValue = i18n.getString(`${prop.property}`);
      const localizedFalseValue = i18n.getString(`FilterOptions_${prop.property}_False`);

      localizedProp.localized.true = localizedTrueValue;
      localizedProp.localized.false = localizedFalseValue;
      if (!_.isEmpty(localizedTrueValue)) {
        localizedProp.description = localizedTrueValue;
      }
    }

    localizedProp.name = localizedProp.title;
    return localizedProp;
  });
  return schema;
}
